import { usePostLogout } from '@repo/api/auth/usePostLogout';
import { baseErrorMessages } from '@repo/lib/messages/baseErrorMessages';
import { getUserLvl } from '@repo/lib/user-lvl/getUserLvl';
import { ChevronsUpDownIcon, LogOutIcon, SettingsIcon, UserIcon } from 'lucide-react';
import { NavLink, useNavigate } from 'react-router';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem, useSidebar } from '@/components/ui/sidebar';
import { toasterMessageHandler } from '@/lib/toaster-message-handler';
import { useCredentials, useRemoveCredentials } from '@/store/auth-store';

export function NavUser() {
  const { name, surname, lvl, avatarURL, accountType } = useCredentials();
  const { isMobile, setOpenMobile } = useSidebar();
  const navigate = useNavigate();
  const removeCredentials = useRemoveCredentials();
  const { mutateAsync } = usePostLogout();

  const userRole = getUserLvl(lvl, accountType);

  const handleNavClick = () => {
    if (isMobile) {
      setOpenMobile(false);
    }
  };

  const logout = async () => {
    await mutateAsync()
      .then(() => {
        removeCredentials();
        navigate('/login');
      })
      .catch((error) => {
        toasterMessageHandler(baseErrorMessages, error);
      });
  };

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-accent/80 data-[state=open]:text-foreground h-full! rounded-t-none rounded-b-lg p-4 group-data-[collapsible=icon]:h-full! group-data-[collapsible=icon]:w-full! group-data-[collapsible=icon]:p-4!"
            >
              <Avatar size={'md'}>
                <AvatarImage src={avatarURL ?? undefined} alt={name} />
                <AvatarFallback>
                  <UserIcon />
                </AvatarFallback>
              </Avatar>
              <div className="grid flex-1 text-left leading-tight">
                <span className="text-foreground truncate text-sm font-semibold">
                  {name} {surname}
                </span>
                <span className="text-muted-foreground truncate text-xs">{userRole}</span>
              </div>
              <ChevronsUpDownIcon className="text-muted-foreground ml-auto size-2.5 shrink-0" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="w-[--radix-dropdown-menu-trigger-width] min-w-56" side={isMobile ? 'bottom' : 'right'} align="end" sideOffset={4}>
            <DropdownMenuLabel className="flex items-center gap-2">
              <Avatar size={'md'}>
                <AvatarImage src={avatarURL ?? undefined} alt={name} />
                <AvatarFallback>
                  <UserIcon />
                </AvatarFallback>
              </Avatar>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="text-foreground truncate font-semibold">
                  {name} {surname}
                </span>
                <span className="text-muted-foreground truncate text-xs">{userRole}</span>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <DropdownMenuItem asChild onClick={handleNavClick}>
                <NavLink to="/settings">
                  <SettingsIcon />
                  Ustawienia
                </NavLink>
              </DropdownMenuItem>
              <DropdownMenuItem asChild onClick={logout}>
                <NavLink to="#">
                  <LogOutIcon />
                  Wyloguj
                </NavLink>
              </DropdownMenuItem>
            </DropdownMenuGroup>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
